<template>
  <v-card flat>
    <v-tabs
      v-if="tabs?.length > 1"
      v-model="activeTab"
    >
      <v-tab
        v-for="tab, index in tabs"
        :key="tab.id"
        :value="tab.id"
        :aria-label="tab.id"
        @click="$emit('tab-selected', index)"
      >
        <InfoWindowTab :tab="tab" />
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script>
import InfoWindowTab from '@/components/InfoWindow/InfoWindowTab.vue';

export default {
  name: 'InfoWindowTabTray',
  components: {
    InfoWindowTab,
  },
  props: {
    // An array of tabs of type InfoWindowContent
    tabs: {
      type: Array,
      default: () => [],
    },
    selectedTab: {
      type: Number,
      default: 0,
    },
  },
  emits: [
    // Used to control which tab is active
    'tab-selected',
  ],
  computed: {
    activeTab: {
      get() {
        return this.selectedTab;
      },
      set(event) {
        this.$emit('tab-selected', event);
      },
    },
  },
};
</script>

<style scoped lang="scss">
// eslint-disable-next-line vue-scoped-css/no-unused-selector
.v-tab.v-tab {
  display: flex;
  min-width: 90px;

  @include main.respond(desktop) {
    min-width: 80px;
  }

  &.v-btn {
    min-width: 70px;
  }
}
</style>
